module.exports = "<div class=Programmes></div>\n<div class=ajouterFraisFixe></div>\n<div class=MontantMaximum></div>";